import { format } from "date-fns";
import { CalendarX } from "lucide-react";
import EventRow from "@/components/calendar/EventRow";
import { toDate, ymd, THEME } from "@/lib/calendar";

const Empty = ({ variant, text }) => (
  <div className={`py-10 text-center ${THEME[variant].muted}`} data-testid="calendar-empty">
    <CalendarX className="w-10 h-10 mx-auto mb-2 opacity-60" />
    <p className="text-sm">{text}</p>
  </div>
);

// Chronological rides grouped under date headers (used for Day, Week and List views)
export const EventList = ({ days, eventsByDate, variant, onOpen, today, audience, hideEmptyDays = false }) => {
  const t = THEME[variant];
  const keys = days ? days.map(ymd) : Object.keys(eventsByDate).sort();
  const visible = hideEmptyDays ? keys.filter((k) => eventsByDate[k]?.length) : keys;
  if (!visible.some((k) => eventsByDate[k]?.length)) {
    return <Empty variant={variant} text="No rides scheduled for this period" />;
  }
  return (
    <div className="space-y-5" data-testid="calendar-event-list">
      {visible.map((k) => (
        <div key={k}>
          <div className="flex items-center gap-2 mb-2">
            <p className={`text-sm font-bold ${k === today ? t.accent : ""}`}>{format(toDate(k), "EEEE, MMM d")}</p>
            {k === today && <span className="text-[10px] font-bold uppercase bg-cyan-600 text-white px-2 rounded-full">Today</span>}
            <span className={`text-xs ${t.muted}`}>{(eventsByDate[k] || []).length} pickup(s)</span>
          </div>
          {(eventsByDate[k] || []).length ? (
            <div className="space-y-2">
              {eventsByDate[k].map((e) => <EventRow key={e.id} event={e} variant={variant} onOpen={onOpen} audience={audience} />)}
            </div>
          ) : (
            <p className={`text-xs ${t.muted}`}>No rides</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default EventList;
